import { getResponseMessage } from '@app/shared/utils/response-message.util';
import { Component, OnInit, inject } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Router, ActivatedRoute } from '@angular/router';
import { RouteUtils } from '@app/core/utils/route.util';
import { MenuItem, MessageService } from 'primeng/api';
import { AuthService } from '@app/auth/services/auth.service';
import {
  FormBuilder,
  FormGroup,
  Validators,
  ReactiveFormsModule,
  FormsModule,
  FormArray,
  AbstractControl,
  ValidationErrors,
  ValidatorFn,
} from '@angular/forms';
import { CommonModule } from '@angular/common';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { SelectModule } from 'primeng/select';
import { InputTextModule } from 'primeng/inputtext';
import { SelectButtonModule } from 'primeng/selectbutton';
import { TextareaModule } from 'primeng/textarea';
import { ButtonModule } from 'primeng/button';
import { EditorModule } from 'primeng/editor';
import { RadioButtonModule } from 'primeng/radiobutton';
import { EnumService } from '@app/shared/components/api/services/enum.service';
import { CategoriaService } from '@app/shared/components/api/services/categoria.service';
import { CampanhaService } from '@app/shared/components/api/services/campanha.service';
import { ProvinciaService } from '@app/shared/components/api/services/provincia.service';
import { InputMaskModule } from 'primeng/inputmask';
import { forkJoin } from 'rxjs';
import { DatePickerModule } from 'primeng/datepicker';
import { DialogModule } from 'primeng/dialog';
import { UserService } from '@app/auth/services/user.service';
import { UtilizadoresService } from '@app/shared/components/api/services/utilizadores.service';
import { AnexoFicheiroService } from '@app/shared/components/api/services/anexo-ficheiro.service';
import {
  dataNaoPodeSerPassadaValidator,
  dataTerminoMaiorQueInicioValidator,
} from '@app/shared/validators/dataNotPast.validator';
import { MoneyPipe } from '@app/shared/pipes/money.pipe';
import { InputNumberModule } from 'primeng/inputnumber';
import { ConfiguracoesService } from '@app/shared/components/api/services/configuracoes.service';
import { allowedSocialMediaValidator } from '@app/shared/validators/socialMedia.validator';
import { HttpParams } from '@angular/common/http';
import { ApiService } from '@core/providers/http';

export interface CampoRequisito {
  id: string;
  label: string;
  step: number;
  valido: boolean;
}

@Component({
  selector: 'app-criar-campanha',
  standalone: true,
  imports: [
    BreadcrumbModule,
    SelectModule,
    ReactiveFormsModule,
    InputMaskModule,
    TextareaModule,
    ButtonModule,
    SelectButtonModule,
    MoneyPipe,
    FormsModule,
    CommonModule,
    InputTextModule,
    EditorModule,
    RadioButtonModule,
    DatePickerModule,
    DialogModule,
    InputNumberModule,
  ],
  templateUrl: './criar-campanha.component.html',
  styleUrls: ['./criar-campanha.component.scss'],
  providers: [
    CategoriaService,
    EnumService,
    UserService,
    ProvinciaService,
    UtilizadoresService,
    AnexoFicheiroService,
    ConfiguracoesService,
  ],
})
export class CriarCampanhaComponent implements OnInit {
  // injections
  private readonly fb = inject(FormBuilder);
  private readonly route = inject(Router);
  private readonly aticeRoute = inject(ActivatedRoute);
  private readonly messageService = inject(MessageService);
  private readonly campanhaService = inject(CampanhaService);
  private readonly categoriaService = inject(CategoriaService);
  private readonly enumService = inject(EnumService);
  private readonly userService = inject(UserService);
  private readonly provinciaService = inject(ProvinciaService);
  private readonly utilizadoresService = inject(UtilizadoresService);
  private readonly anexoFicheiroService = inject(AnexoFicheiroService);
  private readonly sanitizer = inject(DomSanitizer);
  private readonly configuracoesService = inject(ConfiguracoesService);
  private readonly authService = inject(AuthService);
  private readonly apiService = inject(ApiService);

  userdata: any;
  campanhaForm!: FormGroup;
  step: number = 1;
  Isreturn: boolean = true;
  IsSave: boolean = false;
  loading: boolean = false;
  loadingdraft: boolean = false;
  IsEditMode: boolean = false;
  labelDraft: string = '';
  campanhaId: any;
  campanha: any;
  userIban: any;
  mode: any;
  meta: number = 0;
  comissao: number = 0;
  tipoFinanciamentoENUM: number = 1;
  items: MenuItem[] = [];
  home: MenuItem | undefined;

  selectedFile: File | null = null;
  selectedFilePreviewUrl: string | null = null;
  selectedPdF: File | null = null;
  selectedVideo: File | null = null;
  editIndex: number | null = null;
  readonly maxRecompensas: number = 15;

  TipoFinanciamento: { id: number; label: string }[] = [];
  tiposCarregados: boolean = false;
  TipoRecompensaENUMList: { id: number; label: string }[] = [];
  categoriaOptions: { label: string; id: number }[] = [];
  provinciasOptions: { label: string; id: number }[] = [];

  gruposConfiguracao: any[] = [];

  // Parâmetros dinâmicos de Financiamento Recompensa (carregados via GET /Configuracoes/Dominio?configuracoesGeralENUM=3)
  parametrosRecompensaBackend: any[] = [];
  carregandoParametrosRecompensa: boolean = false;

  // Valores reais retornados pela API:
  recompensaDoacaoMinima: number | null = null; // id 6 (Doação mínima)
  recompensaDoacaoMaxima: number | null = null; // id 7 (Doação máxima / Teto)
  recompensaComissao: number | null = null; // id 4 (Comissão por campanha %)
  recompensaTaxaServico: number | null = null; // id 5 (Taxa de serviço %)
  recompensaDuracaoMinima: number | null = null; // id 8 (Duração mínima dias)
  recompensaDuracaoMaxima: number | null = null; // id 9 (Duração máxima dias)
  recompensaQtdProjetosCriador: number | null = null; // id 10 (Qtd. projetos criador)
  recompensaPrazoAlerta: number | null = null; // id 11 (Prazo alerta)
  recompensaAprovacaoCampanha: number | null = null; // id 12 (Aprovação campanha)
  recompensaCampanhaSucesso: number | null = null; // id 13 (Campanha bem sucedida %)

  // Limites aplicados ao formulário (calculados dinamicamente com base na API e na Meta):
  limiteMinimoRecompensa: number = 0;
  limiteMaximoRecompensa: number = 0;

  quantidadeQuantidadeParcelas: { id: number; label: string }[] = [
    { id: 1, label: '1' },
    { id: 2, label: '2' },
    { id: 3, label: '3' },
    { id: 4, label: '4' },
    { id: 5, label: '5' },
    { id: 6, label: '6' },
  ];

  jurosList: { id: number; label: string }[] = [
    { id: 1, label: '1%' },
    { id: 2, label: '2%' },
    { id: 3, label: '3%' },
    { id: 4, label: '4%' },
    { id: 5, label: '5%' },
  ];

  PeriodoReembolsoMesesList: { id: number; label: string }[] = [
    { id: 1, label: '1' },
    { id: 2, label: '2' },
    { id: 3, label: '3' },
    { id: 4, label: '4' },
    { id: 5, label: '5' },
    { id: 6, label: '6' },
    { id: 7, label: '7' },
    { id: 8, label: '8' },
    { id: 9, label: '9' },
    { id: 10, label: '10' },
    { id: 11, label: '11' },
    { id: 12, label: '12' },
  ];

  diasListPadrao = [
    { name: '7', key: '7' },
    { name: '15', key: '15' },
    { name: '30', key: '30' },
    { name: '45', key: '45' },
    { name: '60', key: '60' },
    { name: '75', key: '75' },
    { name: '90', key: '90' },
  ];
  diasList: { name: string; key: string }[] = [
    { name: '7', key: '7' },
    { name: '15', key: '15' },
    { name: '30', key: '30' },
    { name: '45', key: '45' },
    { name: '60', key: '60' },
    { name: '75', key: '75' },
    { name: '90', key: '90' },
  ];

  // archives variables
  imgPreview?: string | null;
  docPreview?: string | null;
  vidPreview?: string | null;
  imgInfo?: { nome: string; tamanho: string; tipo: string } | null;
  docInfo?: { nome: string; tamanho: string; tipo: string } | null;
  VidInfo?: { nome: string; tamanho: string; tipo: string } | null;
  anexoIds: any[] = [];
  AnexoTipoAnexoCampanhaList: any[] = [];
  RemoverAnexoCampanhaList: any[] = [];
  RemoverRecompensaList: number[] = [];
  RemoverTermosEmprestimosList: number[] = [];
  campanhaPreview: any = null;
  ShowPreview: boolean = false;

  campanhaPreviewIMG: File | null = null;
  campanhaPreviewPDF: File | null = null;
  campanhaPreviewVID: File | null = null;

  // variaveis para parametrizacao de dados
  comissaoPorCampanha: number = 0;
  duracaoMin: number = 0;
  duracaoMax: number = 0;
  percentAprovacao: number = 0;

  ngOnInit() {
    if (!this.authService.isLoggedIn()) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Autenticação Necessária',
        detail: 'Inicie sessão na sua conta para criar uma campanha.',
        life: 6000,
      });
      this.route.navigate(['/auth/login'], {
        queryParams: { returnUrl: '/criar-campanha' },
      });
      return;
    }

    const encryptedId = this.aticeRoute.snapshot.paramMap.get('id');
    const id = encryptedId ? RouteUtils.decryptId(encryptedId) : null;
    if (id) {
      this.campanhaId = id;
      this.IsEditMode = true;
      this.labelDraft = 'Atualizar Rascunho';
      this.getCampanhaById(this.campanhaId);
    } else {
      this.labelDraft = 'Guardar como rascunho';
    }
    this.initForm();
    // ensure reward form state respects initial financing type and any existing rewards
    this.handleRecompensaWhenTipo3();
    this.loaddropdowns();
    this.getUserdata();
    this.getTipoFinanciamento();
    this.items = [{ label: 'Criação de campanha' }];
    this.home = { icon: 'pi pi-home', routerLink: '/' };
    this.addSocialLink();
  }

  hoje: Date = new Date();

  initForm() {
    this.campanhaForm = this.fb.group({
      titulo: [null, Validators.required],
      descricaoCurta: [null, [Validators.required, this.maxLengthEditor(180)]],
      descricao: [null, Validators.required],
      tipoFinanciamentoENUM: [null, Validators.required],
      CategoriaID: [null, Validators.required],
      ProvinciaID: [null, Validators.required],
      capaProjeto: [null, Validators.required],
      docProjeto: [null, Validators.required],
      videoProjeto: [null, Validators.required],
      linkVideo: [{ value: null, disabled: false }],
      iban: [
        { value: '', disabled: true },
        [Validators.required, Validators.pattern(/^AO06\d{4}-0000-\d{13}$/)],
      ],
      MetaArrecadar: [null, [Validators.required, Validators.min(1)]],
      // dataInicio: [null, Validators.required],
      // dataTermino: [null, Validators.required],
      RedesSociaisList: this.fb.array([]),
      dias: ['30', Validators.required],
      recompensaForm: this.createRecompensa(),
      recompensas: this.fb.array([]),

      // campos de empréstimo
      ValorSolicitado: [null],
      QuantidadeParcelas: [null],
      PercentualJuros: [null],
      PeriodoReembolsoMeses: [null],
    });
    // { validators: this.dateRangeValidator() }

    this.campanhaForm
      .get('tipoFinanciamentoENUM')
      ?.valueChanges.subscribe((value) => {
        this.tipoFinanciamentoENUM = value;
        this.loaddropdowns();
        // --- Limpar e resetar campos de todos os tipos ---
        const camposEmprestimo = [
          'ValorSolicitado',
          'QuantidadeParcelas',
          'PercentualJuros',
          'PeriodoReembolsoMeses',
        ];
        const camposRecompensa = [
          'Titulo',
          'TipoRecompensaENUM',
          'Descricao',
          'Valor',
          'Quantidade',
          'DataInicioRecompensa',
          'DataTerminoRecompensa',
        ];

        // Função para limpar campos
        const limparCampos = (campos: string[]) => {
          campos.forEach((campo) => {
            this.campanhaForm.get(campo)?.reset();
            this.campanhaForm.get(campo)?.clearValidators();
            this.campanhaForm.get(campo)?.updateValueAndValidity();
          });
        };

        // --- Aplicar validadores dinamicamente ---
        if (value === 2) {
          // Tipo: Empréstimo
          limparCampos(camposRecompensa); // limpa recompensa
          // caso viesse de uma seleção anterior de recompensas, ignoramos validações e conteúdos
          this.ignoreRecompensaFormValidation();

          this.campanhaForm
            .get('ValorSolicitado')
            ?.setValidators([Validators.required, Validators.min(1)]);
          this.campanhaForm
            .get('QuantidadeParcelas')
            ?.setValidators([Validators.required, Validators.min(1)]);
          this.campanhaForm
            .get('PercentualJuros')
            ?.setValidators([Validators.required, Validators.min(1)]);
          this.campanhaForm
            .get('PeriodoReembolsoMeses')
            ?.setValidators([Validators.required, Validators.min(1)]);
        } else if (value === 3) {
          // Tipo: Recompensa
          limparCampos(camposEmprestimo); // limpa empréstimo
          this.carregarParametrosRecompensaDaApi(() => {
            this.handleRecompensaWhenTipo3();
            this.atualizarMetaPorRecompensas(false);
          });
        } else {
          // Tipo: Doação ou Empréstimo
          if (value === 1) {
            this.ignoreRecompensaFormValidation();
          }
          this.restaurarOpcoesDiasPadrao();
        }

        // --- Atualizar todos os campos ---
        [...camposEmprestimo, ...camposRecompensa].forEach((campo) =>
          this.campanhaForm.get(campo)?.updateValueAndValidity(),
        );
      });

    this.campanhaForm.get('descricaoCurta')?.valueChanges.subscribe(() => {
      this.campanhaForm
        .get('descricaoCurta')
        ?.updateValueAndValidity({ emitEvent: false });
    });

    this.campanhaForm
      .get('MetaArrecadar')
      ?.valueChanges.subscribe((valor: number) => {
        this.comissao = valor
          ? +(valor * this.comissaoPorCampanha).toFixed(2) / 100
          : 0;
        this.meta =
          this.campanhaForm.get('MetaArrecadar')?.value + this.comissao;
        if (this.campanhaForm.get('tipoFinanciamentoENUM')?.value === 3) {
          this.recalcularLimitesRecompensa();
        }
      });

    this.campanhaForm.get('dataTermino')?.valueChanges.subscribe(() => {
      this.recompensas.controls.forEach((recompensa) => {
        recompensa.updateValueAndValidity({ onlySelf: true });
      });
    });

    this.campanhaForm.get('linkVideo')?.valueChanges.subscribe(() => {
      const vidCtrl = this.campanhaForm.get('videoProjeto');
      // Remover validators do video apos preencher o link
      vidCtrl?.clearValidators();
      vidCtrl?.updateValueAndValidity();
    });
  }

  // dropdowns
  loaddropdowns() {
    forkJoin({
      // Enums
      TipoRecompensaENUM: this.enumService.getAllTipoRecompensa(),
      duracaoMim: this.configuracoesService.getDuracaoMinima(
        this.tipoFinanciamentoENUM,
      ),
      duracaoMax: this.configuracoesService.getDuracaoMaxima(
        this.tipoFinanciamentoENUM,
      ),
      percentAprovacao: this.configuracoesService.getCampanhaBemSucedida(
        this.tipoFinanciamentoENUM,
      ),
      comissaoPorCampanha: this.configuracoesService.getComissaoCampanha(
        this.tipoFinanciamentoENUM,
      ),
      // Listas
      categoria: this.categoriaService.list({ pageSize: 100 }),
      provincia: this.provinciaService.list({ PageSize: 100 }),
    }).subscribe((response) => {
      this.duracaoMin = response.duracaoMim ?? 0;
      this.duracaoMax = response.duracaoMax ?? 0;
      this.percentAprovacao = response.percentAprovacao ?? 0;
      this.comissaoPorCampanha = response.comissaoPorCampanha ?? 0;

      if (response.TipoRecompensaENUM?.data) {
        this.TipoRecompensaENUMList = Object.entries(
          response.TipoRecompensaENUM.data,
        ).map(([key, value]) => ({
          id: Number(key),
          label: value as string,
        }));
      }
      // Listas
      if (response.categoria?.data) {
        this.categoriaOptions = response.categoria.data.map((item: any) => ({
          label: item.descricao,
          id: item.id,
        }));
      }

      if (response.provincia?.data) {
        this.provinciasOptions = this.mapAndSortOptions(
          response.provincia.data,
        );
      }
    });
  }

  // gets na API
  getTipoFinanciamento() {
    this.enumService.getTipofinanciamentoValid().subscribe({
      next: (res: any) => {
        let responseArray: any[] = [];
        if (Array.isArray(res)) {
          responseArray = res;
        } else if (Array.isArray(res?.data)) {
          responseArray = res.data;
        } else if (Array.isArray(res?.data?.items)) {
          responseArray = res.data.items;
        }

        this.gruposConfiguracao = responseArray;
        this.extrairConfiguracoesRecompensa(responseArray);

        this.TipoFinanciamento = responseArray
          .filter((x: any) => {
            if (!x) return false;
            // Grupo desativado
            if (x.ativo === false) return false;

            // Se possuir configuracaoParametros (ex: retorno de /Configuracoes/Dominio)
            if (
              Array.isArray(x.configuracaoParametros) &&
              x.configuracaoParametros.length > 0
            ) {
              const boolParam = x.configuracaoParametros.find(
                (p: any) =>
                  p.tipoDadoENUM === 5 ||
                  String(p.tipoDado).toLowerCase() === 'boolean' ||
                  (p.parametro &&
                    String(p.parametro)
                      .toLowerCase()
                      .includes('financiamento')),
              );
              if (boolParam) {
                const v = String(boolParam.valor).trim().toLowerCase();
                const isTrue = v === 'true' || v === '1';
                return isTrue && boolParam.ativo !== false;
              }
            }

            // Se possuir propriedade 'valor' direta
            if (x.valor !== undefined && x.valor !== null) {
              const v = String(x.valor).trim().toLowerCase();
              return v === 'true' || v === '1';
            }

            // Se grupo estiver ativo e não houver flag em contrário
            return x.ativo !== false;
          })
          .map((x: any) => ({
            id: Number(
              x.configuracoesGeralENUM ?? x.tipoFinanciamentoENUM ?? x.id,
            ),
            label:
              x.configuracoesGeral ??
              x.tipoFinanciamento ??
              x.label ??
              x.nome ??
              '',
          }));

        this.tiposCarregados = true;

        // Se houver opções disponíveis e o valor selecionado não for uma delas, selecionar a primeira
        if (this.TipoFinanciamento.length > 0) {
          const currentTipo = this.campanhaForm.get(
            'tipoFinanciamentoENUM',
          )?.value;
          const isAtivo = this.TipoFinanciamento.some(
            (t) => t.id === currentTipo,
          );
          if (!isAtivo) {
            this.selectTipoFinanciamento(this.TipoFinanciamento[0].id);
          }
        }
      },
      error: (err: any) => {
        console.error('Erro ao carregar tipos de financiamento:', err);
        this.tiposCarregados = true;
      },
    });
  }

  isTipoAtivo(tipoId: number): boolean {
    if (!this.tiposCarregados) {
      return false;
    }
    return this.TipoFinanciamento.some((t) => t.id === tipoId);
  }

  getCampanhaById(id: string) {
    this.campanhaService.show(id).subscribe({
      next: (res) => {
        this.campanha = res.data;
        this.setFormValues(this.campanha);
        const fotoAnexo = this.campanha.anexoCampanha?.find(
          (a: any) => a?.tipoAnexoCampanha?.tipo === 'Imagem',
        );
        const docAnexo = this.campanha.anexoCampanha?.find(
          (a: any) => a?.tipoAnexoCampanha?.tipo === 'Apresentação',
        );
        const videoAnexo = this.campanha.anexoCampanha?.find(
          (a: any) => a?.tipoAnexoCampanha?.tipo === 'Video',
        );

        if (videoAnexo?.anexo?.id && !videoAnexo.anexo.url) {
          this.getVideoCampanha(videoAnexo.anexo.id);
        }

        if (fotoAnexo?.anexo?.id && !fotoAnexo.anexo.url) {
          this.getPhotoCampanha(fotoAnexo.anexo.id);
        }

        if (docAnexo?.anexo?.id && !docAnexo.anexo.url) {
          this.getDocsCampanha(docAnexo.anexo.id);
        }
        this.loading = false;
      },
      error: (err) => {
        console.error(err);
        this.loading = false;
      },
    });
  }

  getDocsCampanha(id: any) {
    if (!id) return;
    this.anexoIds.push(id);

    this.anexoFicheiroService.getAnexo(id).subscribe({
      next: (DocRes: any) => {
        const blob = DocRes instanceof Blob ? DocRes : new Blob([DocRes]);

        // Converter Blob em File para validação do formulário
        const file = new File([blob], `Apresentação_${id}.pdf`, {
          type: blob.type || 'application/pdf',
        });

        this.campanhaForm.patchValue({ docProjeto: file });

        // Pré-visualização
        this.docPreview = this.sanitizer.bypassSecurityTrustResourceUrl(
          URL.createObjectURL(blob),
        ) as any;

        this.docInfo = {
          nome: file.name,
          tamanho: `${(file.size / 1024).toFixed(2)} KB`,
          tipo: file.type,
        };
      },
      error: (err) => console.error(err),
    });
  }

  getVideoCampanha(id: any) {
    if (!id) return;
    this.anexoIds.push(id);

    this.anexoFicheiroService.getAnexo(id).subscribe({
      next: (vidRes: any) => {
        const blob = vidRes instanceof Blob ? vidRes : new Blob([vidRes]);

        // Converter Blob em File para validação do formulário
        const file = new File([blob], `Video_${id}.mp4`, {
          type: blob.type || 'video/mp4',
        });

        this.campanhaForm.patchValue({ videoProjeto: file });

        this.vidPreview = this.sanitizer.bypassSecurityTrustResourceUrl(
          URL.createObjectURL(blob),
        ) as any;
        this.VidInfo = {
          nome: file.name,
          tamanho: `${(file.size / 1024).toFixed(2)} KB`,
          tipo: file.type,
        };
      },
      error: (err) => console.error(err),
    });
  }

  getPhotoCampanha(id: any) {
    if (!id) return;
    this.anexoIds.push(id);

    this.anexoFicheiroService.getAnexo(id).subscribe({
      next: (fotoRes: any) => {
        const blob = fotoRes instanceof Blob ? fotoRes : new Blob([fotoRes]);

        // Criar File a partir do Blob para validação do formulário
        const file = new File([blob], `Imagem_${id}.jpg`, {
          type: blob.type || 'image/jpeg',
        });

        this.campanhaForm.patchValue({ capaProjeto: file });
        this.imgPreview = this.sanitizer.bypassSecurityTrustUrl(
          URL.createObjectURL(blob),
        ) as any;

        // Informações da imagem
        this.imgInfo = {
          nome: file.name,
          tamanho: `${(file.size / 1024).toFixed(2)} KB`,
          tipo: file.type,
        };
      },
      error: (err) => console.error(err),
    });
  }

  getUserdata() {
    const userId = this.userService.getUserId();
    if (userId) {
      this.utilizadoresService.show(userId).subscribe({
        next: (res) => {
          this.userdata = res.data;
          this.userIban = this.userdata.iban;
          this.campanhaForm.get('iban')?.setValue(this.userIban);
        },
      });
    } else {
      this.messageService.add({
        severity: 'warn',
        summary: 'Sessão Expirada',
        detail: 'Faça login para continuar',
        life: 5000,
      });
      setTimeout(() => {
        this.route.navigate(['/']);
      }, 3000);
    }
  }

  /** --- Funções de Upload --- **/
  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (!input.files?.length) return;

    const file = input.files[0];
    const validTypes = ['image/png', 'image/jpeg', 'image/jpg'];

    if (!validTypes.includes(file.type) || file.size > 5 * 1024 * 1024) {
      this.messageService.add({
        severity: 'error',
        summary: 'Erro',
        detail: 'Apenas imagens PNG, JPG ou JPEG até 5MB são permitidas.',
        life: 5000,
      });
      input.value = '';
      return;
    }

    this.selectedFile = file;
    this.selectedFilePreviewUrl = URL.createObjectURL(file);
    this.campanhaPreviewIMG = file;
    this.campanhaForm.patchValue({ capaProjeto: file });
  }

  onVideoSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (!input.files?.length) return;

    const file = input.files[0]; // sempre o primeiro selecionado
    const validTypes = ['video/mp4', 'video/mpeg', 'video/quicktime'];
    const linkCtrl = this.campanhaForm.get('linkVideo');
    // Limpa o link quando um ficheiro de vídeo é subido e desabilita o campo
    linkCtrl?.setValue(null);
    linkCtrl?.clearValidators();
    linkCtrl?.disable();
    linkCtrl?.updateValueAndValidity({ emitEvent: false });

    if (!validTypes.includes(file.type) || file.size > 40 * 1024 * 1024) {
      this.messageService.add({
        severity: 'error',
        summary: 'Erro',
        detail: 'Apenas vídeos MP4, MPEG ou MOV até 40MB são permitidos.',
      });
      input.value = '';
      return;
    }

    this.selectedVideo = file;
    this.campanhaPreviewVID = file;
    this.campanhaForm.patchValue({ videoProjeto: file });
  }

  removeVideo(): void {
    this.selectedVideo = null;
    this.vidPreview = undefined;
    this.VidInfo = undefined;
    this.campanhaPreviewVID = null;
    this.campanhaForm.patchValue({ videoProjeto: null });

    const fileInput = document.getElementById(
      'video-upload',
    ) as HTMLInputElement;
    if (fileInput) {
      fileInput.value = '';
    }

    const linkCtrl = this.campanhaForm.get('linkVideo');
    // Re-ativar o campo e aplicar validação de URL (e obrigatoriedade se desejar)
    linkCtrl?.enable();
    linkCtrl?.setValidators([
      Validators.required,
      Validators.pattern(/^https?:\/\/.+/),
    ]);
    linkCtrl?.updateValueAndValidity();
  }

  removeFile(): void {
    this.selectedFile = null;
    this.selectedFilePreviewUrl = null;
    this.imgPreview = undefined;
    this.imgInfo = undefined;
    this.campanhaPreviewIMG = null;
    this.campanhaForm.patchValue({ capaProjeto: null });

    const fileInput = document.getElementById(
      'capa-upload',
    ) as HTMLInputElement;
    if (fileInput) {
      fileInput.value = '';
    }
  }

  onPdFSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (!input.files?.length) return;

    const file = input.files[0];
    const validTypes = ['application/pdf'];

    if (!validTypes.includes(file.type) || file.size > 10 * 1024 * 1024) {
      this.messageService.add({
        severity: 'error',
        summary: 'Erro',
        detail: 'Apenas arquivos PdF até 4MB são permitidos.',
        life: 5000,
      });
      input.value = '';
      return;
    }

    this.selectedPdF = file;
    this.campanhaPreviewPDF = file;
    this.campanhaForm.patchValue({ docProjeto: file });
  }

  removePdF(): void {
    this.selectedPdF = null;
    this.docPreview = undefined;
    this.docInfo = undefined;
    this.campanhaPreviewPDF = null;
    this.campanhaForm.patchValue({ docProjeto: null });

    const fileInput = document.getElementById('pdf-upload') as HTMLInputElement;
    if (fileInput) {
      fileInput.value = '';
    }
  }

  selectTipoFinanciamento(tipo: number): void {
    this.campanhaForm.get('tipoFinanciamentoENUM')?.setValue(tipo);
    this.campanhaForm.get('tipoFinanciamentoENUM')?.markAsDirty();
    this.campanhaForm.get('tipoFinanciamentoENUM')?.markAsTouched();
  }

  goToStep(targetStep: number): void {
    if (targetStep >= 1 && targetStep <= 3) {
      this.step = targetStep;
      this.syncStepState();
      this.scrollToTop(300);
    }
  }

  getCategoriaDesc(id: any): string {
    const cat = this.categoriaOptions.find((c) => c.id === Number(id));
    return cat ? cat.label : 'Categoria';
  }

  getProvinciaDesc(id: any): string {
    const prov = this.provinciasOptions.find((p) => p.id === Number(id));
    return prov ? prov.label : 'Angola';
  }

  /** --- Navegação entre Steps --- **/
  advanceStep() {
    if (this.step < 3) {
      this.step++;
    }
    this.scrollToTop(300);
    this.syncStepState();
  }

  returntep() {
    if (this.step > 1) {
      this.step--;
    } else {
      // Se estiver no primeiro passo, ativa modo "cancelar"
      this.Isreturn = true;
    }
    this.scrollToTop(300);
    this.syncStepState();
  }

  toHome() {
    this.campanhaForm.reset();
    this.step = 1;
    this.syncStepState();
    this.route.navigate(['/']);
  }

  private syncStepState() {
    this.IsSave = this.step === 3; // Só mostra "Publicar" no último passo
    this.Isreturn = this.step === 1; // Mostra "Cancelar" apenas no primeiro passo
  }

  get RedesSociaisList(): FormArray {
    return this.campanhaForm.get('RedesSociaisList') as FormArray;
  }

  get recompensaForm(): FormGroup {
    return this.campanhaForm.get('recompensaForm') as FormGroup;
  }

  get recompensas(): FormArray {
    return this.campanhaForm.get('recompensas') as FormArray;
  }

  createRecompensa(): FormGroup {
    return this.fb.group(
      {
        Id: [null], // ← ESSENCIAL para edição/remoção

        Titulo: [null, Validators.required],
        TipoRecompensaENUM: [null, Validators.required],
        Descricao: [null, Validators.required],

        Valor: [
          null,
          [
            Validators.required,
            Validators.min(this.limiteMinimoRecompensa),
            Validators.max(this.limiteMaximoRecompensa),
          ],
        ],

        Quantidade: [null, Validators.required],

        DataInicioRecompensa: [
          null,
          [Validators.required, dataNaoPodeSerPassadaValidator()],
        ],

        DataTerminoRecompensa: [null, Validators.required],
      },
      {
        validators: dataTerminoMaiorQueInicioValidator(),
      },
    );
  }

  addRecompensa(): void {
    this.recompensaForm.enable({ emitEvent: false });
    this.applyRecompensaValidators(this.recompensaForm);
    this.recalcularLimitesRecompensa();

    if (this.recompensaForm.invalid) {
      this.recompensaForm.markAllAsTouched();

      // Se for edição de recompensa ou campanha, ignora erro de dataPassada caso exista
      const dataPassadaError = this.recompensaForm.get('DataInicioRecompensa')
        ?.errors?.['dataPassada'];
      if (dataPassadaError && (this.editIndex !== null || this.IsEditMode)) {
        const errors = {
          ...this.recompensaForm.get('DataInicioRecompensa')?.errors,
        };
        delete errors['dataPassada'];
        this.recompensaForm
          .get('DataInicioRecompensa')
          ?.setErrors(Object.keys(errors).length ? errors : null);
      }

      if (this.recompensaForm.invalid) {
        if (
          this.recompensaForm.get('DataInicioRecompensa')?.errors?.[
            'dataPassada'
          ]
        ) {
          this.toast(
            'error',
            'Data inválida',
            'A data de início não pode ser no passado.',
          );
          return;
        }

        if (this.recompensaForm.errors?.['dataTerminoInvalida']) {
          this.toast(
            'error',
            'Datas inválidas',
            'A data de término deve ser posterior à data de início.',
          );
          return;
        }

        if (
          this.recompensaForm.get('Valor')?.errors?.['min'] ||
          this.recompensaForm.get('Valor')?.errors?.['max']
        ) {
          this.toast(
            'error',
            'Valor de recompensa fora dos limites',
            `O valor deve ser de no mínimo ${this.limiteMinimoRecompensa.toLocaleString('pt-AO')} Kz.`,
          );
          return;
        }

        this.toast(
          'error',
          'Campos obrigatórios',
          'Preencha todos os campos da recompensa antes de adicionar.',
        );
        return;
      }
    }

    const recompensaValue = this.recompensaForm.getRawValue();
    const dataInicioRec = recompensaValue.DataInicioRecompensa
      ? this.normalizarData(recompensaValue.DataInicioRecompensa)
      : null;
    const terminoCampanha = this.getDataTerminoCampanha();

    // REGRA: Primeiro termina a campanha e só depois se dão as recompensas.
    // A data de início da recompensa deve ser posterior (ou igual) ao término da campanha.
    if (dataInicioRec && terminoCampanha && dataInicioRec.getTime() < terminoCampanha.getTime()) {
      this.toast(
        'error',
        'Data de início da recompensa inválida',
        `A data de início da recompensa (${dataInicioRec.toLocaleDateString('pt-AO')}) deve ser posterior à data de término da campanha (${terminoCampanha.toLocaleDateString('pt-AO')}), pois as recompensas só são liberadas após a campanha atingir a meta e terminar.`,
      );
      return;
    }

    // EDITAR
    if (this.editIndex !== null) {
      const existingCtrl = this.recompensas.at(this.editIndex);
      const existingId = existingCtrl.get('Id')?.value;

      existingCtrl.patchValue({
        ...recompensaValue,
        Id: existingId, // ← preserva vínculo com backend
      });

      this.editIndex = null;

      this.toast('success', 'Atualizado', 'Recompensa atualizada com sucesso.');
      this.atualizarMetaPorRecompensas(true);
    }

    // NOVA
    else {
      if (this.recompensas.length >= this.maxRecompensas) {
        this.toast(
          'warn',
          'Limite atingido',
          `É permitido adicionar no máximo ${this.maxRecompensas} recompensas.`,
        );
        return;
      }

      const nova = this.createRecompensa();
      nova.patchValue(recompensaValue);

      this.recompensas.push(nova);
      this.atualizarMetaPorRecompensas(true);
    }

    // Limpa o construtor e desativa os validadores para não travar a criação da campanha
    this.recompensaForm.reset();
    this.clearRecompensaValidators(this.recompensaForm);
  }

  removeRecompensa(index: number) {
    const recompensaCtrl = this.recompensas.at(index);
    const id = recompensaCtrl.get('Id')?.value;

    if (id) {
      this.RemoverRecompensaList.push(Number(id));
    }

    this.recompensas.removeAt(index);

    if (this.recompensas.length === 0) {
      this.handleRecompensaWhenTipo3();
    }
    this.atualizarMetaPorRecompensas(true);
  }

  editRecompensa(index: number) {
    this.recompensaForm.enable();
    this.editIndex = index;
    this.applyRecompensaValidators(this.recompensaForm);

    const recompensa = this.recompensas.at(index).getRawValue();
    const dataInicio = recompensa.DataInicioRecompensa
      ? recompensa.DataInicioRecompensa instanceof Date
        ? recompensa.DataInicioRecompensa
        : new Date(recompensa.DataInicioRecompensa)
      : null;
    const dataTermino = recompensa.DataTerminoRecompensa
      ? recompensa.DataTerminoRecompensa instanceof Date
        ? recompensa.DataTerminoRecompensa
        : new Date(recompensa.DataTerminoRecompensa)
      : null;

    this.recompensaForm.patchValue({
      Id: recompensa.Id,
      Titulo: recompensa.Titulo,
      TipoRecompensaENUM: recompensa.TipoRecompensaENUM,
      Descricao: recompensa.Descricao,
      Valor: recompensa.Valor,
      Quantidade: recompensa.Quantidade,
      DataInicioRecompensa: dataInicio,
      DataTerminoRecompensa: dataTermino,
    });

    const formEl = document.querySelector(
      '.recompensa-form-box, #recompensaForm',
    );
    if (formEl) {
      formEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }

  cancelarEdicaoRecompensa(): void {
    this.editIndex = null;
    this.recompensaForm.reset();
    if (this.recompensas.length > 0) {
      this.clearRecompensaValidators(this.recompensaForm);
    }
  }

  getSomaRecompensas(): number {
    if (!this.recompensas || this.recompensas.length === 0) return 0;
    return this.recompensas.controls.reduce(
      (total: number, ctrl: AbstractControl) => {
        const val = this.parseValor(ctrl.get('Valor')?.value) || 0;
        const qtdRaw = ctrl.get('Quantidade')?.value;
        const qtd =
          qtdRaw !== null && qtdRaw !== undefined && !isNaN(Number(qtdRaw))
            ? Math.max(1, Number(qtdRaw))
            : 1;
        return total + val * qtd;
      },
      0,
    );
  }

  getSubtotalRecompensa(ctrl: AbstractControl | any): number {
    const raw = ctrl instanceof AbstractControl ? ctrl.value : ctrl;
    const val = this.parseValor(raw?.Valor) || 0;
    const qtdRaw = raw?.Quantidade;
    const qtd =
      qtdRaw !== null && qtdRaw !== undefined && !isNaN(Number(qtdRaw))
        ? Math.max(1, Number(qtdRaw))
        : 1;
    return val * qtd;
  }

  formatarKz(val: number): string {
    return Number(val || 0).toLocaleString('pt-AO', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    });
  }

  atualizarMetaPorRecompensas(notificarUser: boolean = false): void {
    const tipo = Number(this.campanhaForm.get('tipoFinanciamentoENUM')?.value);
    if (tipo !== 3) {
      return;
    }

    const somaRecompensas = this.getSomaRecompensas();
    const taxaPct = this.comissaoPorCampanha || this.recompensaComissao || 1.6;
    const comissaoCalculada =
      somaRecompensas > 0 ? +(somaRecompensas * (taxaPct / 100)).toFixed(2) : 0;
    const metaTotal = somaRecompensas + comissaoCalculada;

    this.comissao = comissaoCalculada;
    this.meta = metaTotal;

    // Coloca a soma das recompensas no MetaArrecadar do formulário para validação e persistência
    this.campanhaForm.get('MetaArrecadar')?.setValue(somaRecompensas, {
      emitEvent: false,
    });
    this.campanhaForm.get('MetaArrecadar')?.markAsDirty();
    this.campanhaForm.get('MetaArrecadar')?.updateValueAndValidity({
      emitEvent: false,
    });

    this.recalcularLimitesRecompensa();

    if (notificarUser) {
      if (somaRecompensas > 0) {
        this.messageService.add({
          severity: 'info',
          summary: 'Meta da Campanha Atualizada',
          detail: `A meta da campanha foi calculada em ${this.formatarKz(
            metaTotal,
          )} Kz (Soma das recompensas [Valor × Qtd]: ${this.formatarKz(
            somaRecompensas,
          )} Kz + Taxa da plataforma de ${taxaPct}%: ${this.formatarKz(
            comissaoCalculada,
          )} Kz).`,
          life: 6000,
        });
      } else {
        this.messageService.add({
          severity: 'warn',
          summary: 'Meta da Campanha',
          detail:
            'A lista de recompensas está vazia. Adicione recompensas no Passo 1 para calcular a meta da campanha.',
          life: 5000,
        });
      }
    }
  }

  normalizarData(d: Date | string): Date {
    const data = new Date(d);
    data.setHours(0, 0, 0, 0);
    return data;
  }

  getDataInicioCampanha(): Date {
    if (this.campanha?.dataInicio) {
      return this.normalizarData(this.campanha.dataInicio);
    }
    if (this.campanha?.dataCriacao) {
      return this.normalizarData(this.campanha.dataCriacao);
    }
    const hoje = new Date();
    hoje.setHours(0, 0, 0, 0);
    return hoje;
  }

  getDataTerminoCampanha(diasParam?: number): Date | null {
    const rawDias = diasParam ?? Number(this.campanhaForm.get('dias')?.value);
    const durMinApi = Number(this.recompensaDuracaoMinima || 7);
    const dias = rawDias && rawDias > 0 ? rawDias : durMinApi;
    const inicio = this.getDataInicioCampanha();
    const termino = new Date(inicio);
    termino.setDate(termino.getDate() + dias);
    termino.setHours(0, 0, 0, 0);
    return termino;
  }

  getMenorDataInicioRecompensas(): Date | null {
    if (!this.recompensas || this.recompensas.length === 0) return null;
    let menor: Date | null = null;
    for (const ctrl of this.recompensas.controls) {
      const dtVal = ctrl.get('DataInicioRecompensa')?.value;
      if (dtVal) {
        const d = this.normalizarData(dtVal);
        if (!isNaN(d.getTime())) {
          if (!menor || d < menor) {
            menor = d;
          }
        }
      }
    }
    return menor;
  }

  isDuracaoUltrapassaInicioRecompensas(diasKey: string | number): boolean {
    if (this.campanhaForm.get('tipoFinanciamentoENUM')?.value !== 3) {
      return false;
    }
    const dias = Number(diasKey);
    if (!dias) return false;
    const menorInicio = this.getMenorDataInicioRecompensas();
    if (!menorInicio) return false;

    const terminoCampanha = this.getDataTerminoCampanha(dias);
    if (!terminoCampanha) return false;

    return terminoCampanha.getTime() > menorInicio.getTime();
  }

  selecionarDuracao(diasKey: string | number): void {
    const diasStr = String(diasKey);
    this.campanhaForm.get('dias')?.setValue(diasStr);
    this.campanhaForm.get('dias')?.markAsDirty();
    this.campanhaForm.get('dias')?.markAsTouched();

    if (this.isDuracaoUltrapassaInicioRecompensas(diasStr)) {
      const menorInicio = this.getMenorDataInicioRecompensas();
      const termino = this.getDataTerminoCampanha(Number(diasKey));
      this.toast(
        'warn',
        'Aviso de Cronograma',
        `Com ${diasStr} dias a campanha terminará em ${termino ? termino.toLocaleDateString('pt-AO') : ''}, ultrapassando o início da entrega de recompensas (${menorInicio ? menorInicio.toLocaleDateString('pt-AO') : ''}). As recompensas só devem iniciar após o término da campanha.`,
      );
    }
  }

  onDiasInputChange(event: any): void {
    const val = event?.target?.value;
    if (val !== undefined && val !== null && val !== '') {
      this.campanhaForm.get('dias')?.setValue(String(val));
      this.campanhaForm.get('dias')?.markAsDirty();
      this.campanhaForm.get('dias')?.markAsTouched();
    }
  }

  garantirDuracaoMinimaCampanha(diasMinimos: number): void {
    const diasAtuais = Number(this.campanhaForm.get('dias')?.value) || 0;
    if (diasAtuais < diasMinimos) {
      const opcaoValida = this.diasList.find(
        (opt) => Number(opt.key) >= diasMinimos,
      );
      if (opcaoValida) {
        this.campanhaForm.get('dias')?.setValue(opcaoValida.key);
        this.campanhaForm.get('dias')?.markAsDirty();
      } else {
        const durMax = this.recompensaDuracaoMaxima ?? 90;
        const diasAjustados = Math.min(diasMinimos, durMax);
        this.campanhaForm.get('dias')?.setValue(String(diasAjustados));
        this.campanhaForm.get('dias')?.markAsDirty();
      }
    }
  }

  canAddSocialLink(): boolean {
    if (this.RedesSociaisList.length === 0) {
      return true;
    }
    return this.RedesSociaisList.controls.every((ctrl) => {
      const val = (ctrl?.value || '').trim();
      return !!val && ctrl.valid;
    });
  }

  addSocialLink() {
    if (!this.canAddSocialLink()) {
      const hasEmpty = this.RedesSociaisList.controls.some(
        (c) => !(c?.value || '').trim(),
      );
      if (hasEmpty) {
        this.messageService.add({
          severity: 'warn',
          summary: 'Campo Pendente',
          detail:
            'Preencha o link da rede social anterior antes de adicionar um novo campo.',
          life: 4000,
        });
      } else {
        this.messageService.add({
          severity: 'warn',
          summary: 'Link Inválido',
          detail:
            'Insira um link válido da rede social anterior antes de adicionar um novo campo.',
          life: 4000,
        });
      }
      return;
    }

    const control = this.fb.control('', [
      Validators.pattern(/^https?:\/\/.+\..+/),
      allowedSocialMediaValidator(),
    ]);

    // Monitorar mudanças do valor para validação de redes sociais permitidas
    control.valueChanges.subscribe((value) => {
      if (value && control.hasError('invalidSocialMedia')) {
        this.messageService.add({
          severity: 'error',
          summary: 'Rede Social Inválida',
          detail:
            'Apenas são permitidos links do YouTube, LinkedIn, Facebook, Instagram, X (Twitter) ou TikTok.',
          life: 5000,
        });
      }
    });

    this.RedesSociaisList.push(control);
  }

  removeSocialLink(index: number) {
    this.RedesSociaisList.removeAt(index);
  }

  saveCampanha(estadoCampanha: number) {
    if (!this.isFormularioCompleto()) {
      this.campanhaForm.markAllAsTouched();
      this.messageService.add({
        severity: 'warn',
        summary: 'Formulário Incompleto',
        detail:
          estadoCampanha === 1
            ? 'O formulário deve estar 100% preenchido para guardar como rascunho.'
            : 'O formulário deve estar 100% preenchido para publicar a campanha.',
        life: 5000,
      });
      return;
    }

    if (this.campanhaForm.get('tipoFinanciamentoENUM')?.value === 3) {
      if (this.recompensas.length === 0) {
        this.messageService.add({
          severity: 'error',
          summary: 'Erro',
          detail: 'Adicione pelo menos uma recompensa.',
          life: 5000,
        });

        return;
      }

      if (!this.validarRecompensasAntesDeEnviar()) {
        return;
      }

      // Uma vez que já tem recompensa adicionada na lista, as validações do formulário construtor são opcionais:
      this.clearRecompensaValidators(this.recompensaForm);
    }

    if (this.campanhaForm.get('tipoFinanciamentoENUM')?.value !== 3) {
      this.ignoreRecompensaFormValidation();
    }

    if (this.campanhaForm.invalid) {
      this.campanhaForm.markAllAsTouched();
      this.messageService.add({
        severity: 'error',
        summary: 'Erro',
        detail: 'Formulário inválido. Verifique os campos obrigatórios.',
        life: 5000,
      });
      this.logInvalidControls(this.campanhaForm);

      return;
    }
    // Validações personalizadas
    // if (this.campanhaForm.hasError('dateRangeInvalid')) {
    //   this.messageService.add({
    //     severity: 'error',
    //     summary: 'Erro',
    //     detail: 'A data de término deve ser posterior à data de início.'
    //   });
    //   return;
    // } else if (this.campanhaForm.hasError('minDuration')) {
    //   const actual = this.campanhaForm.getError('minDuration')?.actual;
    //   this.messageService.add({
    //     severity: 'error',
    //     summary: 'Erro',
    //     detail: `A duração mínima é 7 dias. Você selecionou ${actual} dias.`
    //   });
    //   return;
    // } else if (this.campanhaForm.hasError('maxDuration')) {
    //   const actual = this.campanhaForm.getError('maxDuration')?.actual;
    //   this.messageService.add({
    //     severity: 'error',
    //     summary: 'Erro',
    //     detail: `A duração máxima é 90 dias. Você selecionou ${actual} dias.`
    //   });
    //   return;
    // } else if (this.campanhaForm.hasError('pastDate')) {
    //   this.messageService.add({
    //     severity: 'error',
    //     summary: 'Erro',
    //     detail: 'A data de início não pode ser anterior à data atual.'
    //   });
    //   return;
    // }

    const utilizadorID = this.userService.getUserId();
    if (utilizadorID === null) {
      throw new Error('UtilizadorID não encontrado');
    }

    if (!this.isValidGuid(utilizadorID)) {
      throw new Error('UtilizadorID inválido');
    }

    // Inicio do processo de salvamento da campanha
    if (estadoCampanha === 1) {
      this.loadingdraft = true;
      this.labelDraft = 'Guardando...';
    } else {
      this.loading = true;
      this.recompensaForm.disable({ emitEvent: false });
    }
    const v = this.campanhaForm.value;

    // const toYMd = (d: Date) => {
    //   const y = d.getFullYear();
    //   const m = String(d.getMonth() + 1).padStart(2, '0');
    //   const day = String(d.getDate()).padStart(2, '0');
    //   return `${y}-${m}-${day}`;
    // };

    // const adddays = (d: Date, n: number) => {
    //   const c = new Date(d);
    //   c.setDate(c.getDate() + n);
    //   return c;
    // };

    // duração
    // let duracaodays = Number(
    //   typeof v.duracao === 'object'
    //     ? (v.duracao?.key ?? v.duracao?.name)
    //     : v.duracao
    // );
    // if (!Number.isFinite(duracaodays)) duracaodays = 7;
    // duracaodays = Math.max(7, Math.min(90, duracaodays));

    // // datas
    // let start = v.dataInicio ? new Date(v.dataInicio) : new Date();
    // start.setHours(0, 0, 0, 0);

    // let end = v.dataTermino ? new Date(v.dataTermino) : adddays(start, duracaodays);
    // end.setHours(0, 0, 0, 0);

    // const diffdays = Math.round((end.getTime() - start.getTime()) / 86400000);
    // if (diffdays < 7) end = adddays(start, 7);

    // const maxEnd = adddays(start, 90);
    // if (end.getTime() > maxEnd.getTime()) end = maxEnd;

    // Monta JSON base
    const campanhaJson: any = {
      Id: 0,
      Titulo: v.titulo,
      descricao: v.descricao,
      descricaoCurta: this.stripHtmlTags(v.descricaoCurta),
      CategoriaID: v.CategoriaID,
      ProvinciaID: v.ProvinciaID,
      MetaArrecadar:
        v.tipoFinanciamentoENUM === 2
          ? this.parseValor(v.ValorSolicitado)
          : this.meta,
      Dias: Number(v.dias) || 0,
      dias: Number(v.dias) || 0,
      ValorArrecado: 0.0,
      EstadoCampanhaENUM: estadoCampanha,
      NivelFinanciamentoENUM: 1,
      tipoFinanciamentoENUM: v.tipoFinanciamentoENUM,
      redesSociaisList: (this.RedesSociaisList.value || []).filter(
        (s: string) => !!(s && s.trim()),
      ),
      MotivoSuspencao: '',
      UtilizadorID: utilizadorID,
      AnexoTipoAnexoCampanhaList: [],
    };

    // Adiciona listas de acordo com tipoFinanciamentoENUM
    if (this.campanhaForm.get('tipoFinanciamentoENUM')?.value === 2) {
      campanhaJson.TermosEmprestimosList = [
        {
          ValorSolicitado: this.parseValor(v.ValorSolicitado),
          PercentualJuros: v.PercentualJuros,
          QuantidadeQuantidadeParcelas: v.QuantidadeParcelas,
          PeriodoReembolsoMeses: v.PeriodoReembolsoMeses,
        },
      ];
      campanhaJson.RecompensaList = [];
    } else if (this.campanhaForm.get('tipoFinanciamentoENUM')?.value === 3) {
      const toDateTime = (value: any) => {
        if (!value) return null;
        const d = new Date(value);
        return isNaN(d.getTime()) ? null : d.toISOString().slice(0, 19);
      };
      campanhaJson.RecompensaList = this.recompensas.controls.map(
        (ctrl: any) => {
          const r = ctrl.value;
          const recObj: any = {
            Titulo: r.Titulo,
            Descricao: r.Descricao,
            Valor: Number(r.Valor),
            Quantidade: Number(r.Quantidade),
            QuantidadeDisponivel: Number(r.Quantidade),
            DataIncioRecompensa: toDateTime(r.DataInicioRecompensa),
            DataInicioRecompensa: toDateTime(r.DataInicioRecompensa),
            DataTerminoRecompensa: toDateTime(r.DataTerminoRecompensa),
            TipoRecompensaENUM: Number(r.TipoRecompensaENUM),
          };
          if (r.Id) {
            recObj.Id = Number(r.Id);
          }
          return recObj;
        },
      );
      campanhaJson.TermosEmprestimosList = [];
    } else {
      campanhaJson.RecompensaList = [];
      campanhaJson.TermosEmprestimosList = [];
    }

    // Anexos obrigatórios | opcionais
    if (this.selectedFile) {
      campanhaJson.AnexoTipoAnexoCampanhaList.push({
        AnexoUrl: '',
        Anexodescricao: 'Foto do projeto',
        TipoAnexoCampanha: 'Imagem',
      });
    }

    if (this.selectedVideo) {
      campanhaJson.AnexoTipoAnexoCampanhaList.push({
        AnexoUrl: '',
        Anexodescricao: 'Video do projeto',
        TipoAnexoCampanha: 'Video',
      });
    }

    if (this.selectedPdF) {
      campanhaJson.AnexoTipoAnexoCampanhaList.push({
        AnexoUrl: '',
        Anexodescricao: 'documento de apresentação',
        TipoAnexoCampanha: 'Apresentação',
      });
    }

    if (v.linkVideo) {
      campanhaJson.AnexoTipoAnexoCampanhaList.push({
        AnexoUrl: v.linkVideo,
        Anexodescricao: 'Link do Video do projeto',
        TipoAnexoCampanha: 'Video',
      });
    }

    if (campanhaJson.AnexoTipoAnexoCampanhaList.length === 0) {
      this.messageService.add({
        severity: 'error',
        summary: 'Erro',
        detail: 'Selecione pelo menos um anexo (imagem, vídeo ou PdF).',
        life: 5000,
      });
      return;
    }

    // Envio
    const formdata = new FormData();
    formdata.append('Json', JSON.stringify(campanhaJson));

    if (this.selectedFile) {
      formdata.append(
        'FicheiroList',
        this.selectedFile,
        this.selectedFile.name,
      );
    }

    if (this.selectedVideo) {
      formdata.append(
        'FicheiroList',
        this.selectedVideo,
        this.selectedVideo.name,
      );
    }

    if (this.selectedPdF) {
      formdata.append('FicheiroList', this.selectedPdF, this.selectedPdF.name);
    }

    // log payload contents (FormData doesn't stringify nicely)
    Array.from(formdata.entries()).forEach(([k, v]) => {});

    this.campanhaService.store(formdata).subscribe({
      next: (res: any) => {
        const retorno = res?.retorno;
        const codigo = retorno?.codigo ?? res?.codigo;
        const mensagem = retorno?.mensagem || res?.mensagem;

        if (codigo === 200) {
          this.messageService.add({
            severity: 'success',
            summary: 'Sucesso',
            detail:
              mensagem ||
              (estadoCampanha === 1
                ? 'Rascunho guardado com sucesso'
                : 'A sua campanha foi criada com sucesso! Aguarde a aprovação.'),
            life: 8000,
          });
          this.loading = false;
          this.loadingdraft = false;
          // Redireciona para a página de detalhe da campanha após 2 segundos
          setTimeout(() => {
            this.route.navigate(['/dashboads']);
          }, 2000);
        } else {
          this.messageService.add({
            severity: 'error',
            summary: 'Erro',
            detail: mensagem || 'Falha na operação.',
            life: 8000,
          });
          this.loading = false;
          this.loadingdraft = false;
          this.labelDraft = this.IsEditMode
            ? 'Atualizar Rascunho'
            : 'Guardar como rascunho';
          this.recompensaForm.enable({ emitEvent: false });
        }
      },
      error: (err) => {
        console.error('Erro ao criar campanha:', err);
        const retorno = err?.error?.retorno || err?.retorno;
        const codigo = retorno?.codigo ?? err?.status ?? 400;
        const errorMsg =
          retorno?.mensagem ||
          err?.error?.mensagem ||
          err?.error?.detail ||
          err?.message ||
          'Falha na operação.';

        if (
          typeof errorMsg === 'string' &&
          errorMsg.includes('recompensa deve estar entre')
        ) {
          const match = errorMsg.match(/entre\s+([0-9.,]+)\s+e\s+([0-9.,]+)/i);
          if (match) {
            const minB = this.parseNumeroAngola(match[1]);
            const maxB = this.parseNumeroAngola(match[2]);
            if (!isNaN(minB) && !isNaN(maxB) && minB > 0 && maxB > 0) {
              this.limiteMinimoRecompensa = minB;
              this.limiteMaximoRecompensa = maxB;
              this.aplicarValidadoresValorRecompensa();
            }
          }
        }

        this.messageService.add({
          severity: 'error',
          summary: 'Erro',
          detail: errorMsg,
          life: 8000,
        });
        this.loading = false;
        this.loadingdraft = false;
        this.labelDraft = this.IsEditMode
          ? 'Atualizar Rascunho'
          : 'Guardar como rascunho';
        this.recompensaForm.enable({ emitEvent: false });
      },
    });
  }

  // Edicao de campanhas
  setFormValues(campanha: any) {
    this.campanhaForm.patchValue({
      // CAMPANHA
      titulo: campanha?.titulo,
      descricao: campanha?.descricao,
      descricaoCurta: campanha?.descricaoCurta,
      tipoFinanciamentoENUM: campanha?.tipoFinanciamentoENUM,
      CategoriaID: campanha?.categoria?.id,
      ProvinciaID: campanha?.provincia?.id,
      iban: this.userIban,
      MetaArrecadar: campanha?.metaArrecadar,
      // dataInicio: campanha?.dataCriacaoFormatada,
      // dataTermino: campanha?.dataTerminoFormatada,
      dias:
        campanha?.dias !== null && campanha?.dias !== undefined
          ? String(campanha.dias)
          : '',
      linkVideo:
        campanha?.anexoCampanha?.find(
          (a: any) => a?.tipoAnexoCampanha?.tipo === 'Video',
        )?.anexo?.url || '',
      // recompensas: this.recompensas
    });

    // Se a campanha já tiver um anexo físico do tipo Video, desabilitar o campo de link
    const videoAnexo = campanha?.anexoCampanha?.find(
      (a: any) => a?.tipoAnexoCampanha?.tipo === 'Video',
    );
    if (videoAnexo && !videoAnexo.anexo?.url) {
      const linkCtrl = this.campanhaForm.get('linkVideo');
      linkCtrl?.disable();
      linkCtrl?.clearValidators();
      linkCtrl?.updateValueAndValidity({ emitEvent: false });
    }

    this.recompensas.clear();

    if (Array.isArray(campanha?.recompensa)) {
      campanha.recompensa.forEach((r: any) => {
        const group = this.createRecompensa();
        const inicioRaw = r.dataIncioRecompensa || r.dataInicioRecompensa;
        const terminoRaw = r.dataTerminoRecompensa;
        const dataInicio = inicioRaw ? new Date(inicioRaw) : null;
        const dataTermino = terminoRaw ? new Date(terminoRaw) : null;

        group.patchValue({
          Id: r.id, // ← ESSENCIAL
          Titulo: r.titulo,
          TipoRecompensaENUM: r.tipoRecompensaENUM,
          Descricao: r.descricao,
          Valor: r.valor,
          Quantidade: r.quantidade,
          DataInicioRecompensa: dataInicio,
          DataTerminoRecompensa: dataTermino,
        });
        this.recompensas.push(group);
      });

      this.handleRecompensaWhenTipo3();
      if (campanha?.tipoFinanciamentoENUM === 3) {
        this.atualizarMetaPorRecompensas(false);
      }
    }

    // Carregar redes sociais existentes
    this.RedesSociaisList.clear();
    const redesSociais = campanha?.redesSociaisList;
    if (redesSociais) {
      let links: string[] = [];
      if (Array.isArray(redesSociais)) {
        links = redesSociais;
      } else if (typeof redesSociais === 'string') {
        links = redesSociais
          .split(',')
          .map((link) => link.trim())
          .filter((link) => link);
      }
      links.forEach((link: string) => {
        const control = this.fb.control(link, [
          Validators.pattern(/^https?:\/\/.+\..+/),
          allowedSocialMediaValidator(),
        ]);

        // Monitorar mudanças do valor para validação de redes sociais permitidas
        control.valueChanges.subscribe((value) => {
          if (value && control.hasError('invalidSocialMedia')) {
            this.messageService.add({
              severity: 'error',
              summary: 'Rede Social Inválida',
              detail:
                'Apenas são permitidos links do YouTube, LinkedIn, Facebook, Instagram, X (Twitter) ou TikTok.',
              life: 5000,
            });
          }
        });

        this.RedesSociaisList.push(control);
      });
    }
    if (this.RedesSociaisList.length === 0) {
      this.addSocialLink();
    }

    this.loading = false;
  }

  updateCampanha(estadoCampanha?: number) {
    if (!this.isFormularioCompleto()) {
      this.campanhaForm.markAllAsTouched();
      this.messageService.add({
        severity: 'warn',
        summary: 'Formulário Incompleto',
        detail:
          estadoCampanha === 1
            ? 'O formulário deve estar 100% preenchido para guardar como rascunho.'
            : 'O formulário deve estar 100% preenchido para atualizar e publicar a campanha.',
        life: 5000,
      });
      return;
    }

    if (this.campanhaForm.invalid) {
      this.campanhaForm.markAllAsTouched();
      this.logInvalidControls(this.campanhaForm);
      this.toast('error', 'Erro', 'Formulário inválido.');
      return;
    }

    const payload = this.buildCampanhaPayload(estadoCampanha);

    const formdata = new FormData();
    formdata.append('Json', JSON.stringify(payload));

    if (this.selectedFile)
      formdata.append(
        'FicheiroList',
        this.selectedFile,
        this.selectedFile.name,
      );

    if (this.selectedPdF)
      formdata.append('FicheiroList', this.selectedPdF, this.selectedPdF.name);

    if (this.selectedVideo)
      formdata.append(
        'FicheiroList',
        this.selectedVideo,
        this.selectedVideo.name,
      );

    this.loading = true;
    this.loadingdraft = false;
    this.campanhaService.update(formdata).subscribe({
      next: (res: any) => {
        const retorno = res?.retorno;
        const codigo = retorno?.codigo ?? res?.codigo;
        const mensagem = retorno?.mensagem || res?.mensagem;

        if (codigo === 200) {
          this.messageService.add({
            severity: 'success',
            summary: 'Sucesso',
            detail: mensagem || 'Rascunho atualizado com sucesso!',
            life: 8000,
          });
          this.loadingdraft = false;
          this.loading = false;
          // Redireciona para a página de detalhe da campanha após 2 segundos
          setTimeout(() => {
            this.route.navigate(['/dashboads']);
          }, 2000);
        } else {
          this.messageService.add({
            severity: 'error',
            summary: 'Erro',
            detail: mensagem || 'Falha ao atualizar rascunho.',
            life: 8000,
          });
          this.loading = false;
          this.loadingdraft = false;
          this.recompensaForm.enable({ emitEvent: false });
        }
      },
      error: (err) => {
        console.error('Erro ao atualizar campanha:', err);
        const retorno = err?.error?.retorno || err?.retorno;
        const codigo = retorno?.codigo ?? err?.status ?? 400;
        const errorMsg =
          retorno?.mensagem ||
          err?.error?.mensagem ||
          err?.error?.detail ||
          err?.message ||
          'Falha ao atualizar rascunho.';

        this.messageService.add({
          severity: 'error',
          summary: 'Erro',
          detail: errorMsg,
          life: 8000,
        });
        this.loading = false;
        this.loadingdraft = false;
        this.recompensaForm.enable({ emitEvent: false });
      },
    });
  }

  removeAnexoCampanha(index: number) {
    let removedId: number | null = null;

    if (index === 1 && this.docInfo) {
      removedId = this.extractIdFromName(this.docInfo.nome);
      if (removedId) this.RemoverAnexoCampanhaList.push(removedId);

      this.docPreview = undefined;
      this.docInfo = undefined;
      this.campanhaForm.patchValue({ docProjeto: null });
      this.removePdF();
    }

    if (index === 2 && this.imgInfo) {
      removedId = this.extractIdFromName(this.imgInfo.nome);
      if (removedId) this.RemoverAnexoCampanhaList.push(removedId);

      this.imgPreview = undefined;
      this.imgInfo = undefined;
      this.campanhaForm.patchValue({ capaProjeto: null });
      this.removeFile();
    }

    if (index === 3 && this.VidInfo) {
      removedId = this.extractIdFromName(this.VidInfo.nome);
      if (removedId) this.RemoverAnexoCampanhaList.push(removedId);

      this.vidPreview = undefined;
      this.VidInfo = undefined;
      this.campanhaForm.patchValue({ videoProjeto: null });
      this.removeVideo();
    }
  }

  private buildCampanhaPayload(estadoCampanha?: number): any {
    const v = this.campanhaForm.getRawValue(); // inclui campos disabled
    const userId = this.userService.getUserId();

    const toDateTime = (value: any) => {
      if (!value) return null;
      const d = new Date(value);
      return isNaN(d.getTime()) ? null : d.toISOString().slice(0, 19);
    };

    const payload: any = {
      Id: Number(this.campanhaId),
      Titulo: v.titulo,
      Descricao: v.descricao,
      dias: Number(v.dias) || 0,
      Dias: Number(v.dias) || 0,
      DescricaoCurta: this.stripHtmlTags(v.descricaoCurta),
      CategoriaID: Number(v.CategoriaID),
      MetaArrecadar:
        Number(v.tipoFinanciamentoENUM) === 2
          ? this.parseValor(v.ValorSolicitado)
          : this.meta,
      EstadoCampanhaENUM: estadoCampanha,
      TipoFinanciamentoENUM: Number(v.tipoFinanciamentoENUM),
      // DataInicio: null,
      // DataTermino: null,
      UtilizadorID: userId,
      ProvinciaID: Number(v.ProvinciaID),
      RedesSociaisList: (this.RedesSociaisList.value || []).filter(Boolean),
      RecompensaList: [],
      TermosEmprestimosList: [],
      RemoverRecompensaList: this.RemoverRecompensaList.map((id: number) => ({
        Id: id,
      })),
      RemoverTermosEmprestimosList: this.RemoverTermosEmprestimosList.map(
        (id: number) => ({ Id: id }),
      ),
      RemoverAnexoCampanhaList: this.RemoverAnexoCampanhaList.map(
        (id: number) => ({ Id: id }),
      ),
      AnexoTipoAnexoCampanhaList: [],
    };

    // RECOMPENSAS
    if (payload.TipoFinanciamentoENUM === 3 && this.recompensas.length) {
      payload.RecompensaList = this.recompensas.controls.map((ctrl: any) => {
        const r = ctrl.value;
        const recObj: any = {
          Titulo: r.Titulo,
          Descricao: r.Descricao,
          Valor: Number(r.Valor),
          Quantidade: Number(r.Quantidade),
          QuantidadeDisponivel: Number(r.Quantidade),
          DataIncioRecompensa: toDateTime(r.DataInicioRecompensa),
          DataInicioRecompensa: toDateTime(r.DataInicioRecompensa),
          DataTerminoRecompensa: toDateTime(r.DataTerminoRecompensa),
          TipoRecompensaENUM: Number(r.TipoRecompensaENUM),
        };
        if (r.Id) {
          recObj.Id = Number(r.Id);
        }
        return recObj;
      });
    }

    // EMPRÉSTIMO
    if (payload.TipoFinanciamentoENUM === 2) {
      payload.TermosEmprestimosList = [
        {
          ValorSolicitado: this.parseValor(v.ValorSolicitado),
          PercentualJuros: Number(v.PercentualJuros),
          QuantidadeParcelas: Number(v.QuantidadeParcelas),
          PeriodoReembolsoMeses: Number(v.PeriodoReembolsoMeses),
        },
      ];
    }

    // ANEXOS
    if (this.selectedFile) {
      payload.AnexoTipoAnexoCampanhaList.push({
        TipoAnexoCampanha: 'Imagem',
        AnexoDescricao: 'Foto do projeto',
        AnexoUrl: null,
      });
    }

    if (this.selectedPdF) {
      payload.AnexoTipoAnexoCampanhaList.push({
        TipoAnexoCampanha: 'Apresentação',
        AnexoDescricao: 'Documento de apresentação',
        AnexoUrl: null,
      });
    }

    if (this.selectedVideo) {
      payload.AnexoTipoAnexoCampanhaList.push({
        TipoAnexoCampanha: 'Video',
        AnexoDescricao: 'Vídeo da campanha',
        AnexoUrl: null,
      });
    }

    // Processar mudança de link do vídeo
    const originalVideoLink =
      this.campanha?.anexoCampanha?.find(
        (a: any) => a?.tipoAnexoCampanha?.tipo === 'Video',
      )?.anexo?.url || '';
    if (v.linkVideo !== originalVideoLink) {
      const oldVideoId = this.campanha?.anexoCampanha?.find(
        (a: any) => a?.tipoAnexoCampanha?.tipo === 'Video',
      )?.anexo?.id;
      if (
        oldVideoId &&
        !payload.RemoverAnexoCampanhaList.find((r: any) => r.Id === oldVideoId)
      ) {
        payload.RemoverAnexoCampanhaList.push({ Id: oldVideoId });
      }

      if (v.linkVideo) {
        payload.AnexoTipoAnexoCampanhaList.push({
          TipoAnexoCampanha: 'Video',
          AnexoDescricao: 'Link do Video do projeto',
          AnexoUrl: v.linkVideo,
        });
      }
    }

    return payload;
  }

  private buildRecompensaDTO(): any[] {
    const toDateTime = (value: any) => {
      if (!value) return null;
      const d = new Date(value);
      return isNaN(d.getTime()) ? null : d.toISOString().slice(0, 19);
    };

    return this.recompensas.controls.map((ctrl) => {
      const formGroup = ctrl as FormGroup;
      const r = formGroup.getRawValue();

      return {
        Titulo: r.Titulo,
        Descricao: r.Descricao,
        Valor: Number(r.Valor),
        Quantidade: Number(r.Quantidade),
        QuantidadeDisponivel: Number(r.Quantidade),
        DataIncioRecompensa: toDateTime(r.DataInicioRecompensa),
        DataTerminoRecompensa: toDateTime(r.DataTerminoRecompensa),
        TipoRecompensaENUM: Number(r.TipoRecompensaENUM),
      };
    });
  }

  // validators
  dateRangeValidator(): ValidatorFn {
    return (group: AbstractControl): ValidationErrors | null => {
      const inicio = group.get('dataInicio')?.value;
      const termino = group.get('dataTermino')?.value;

      if (!inicio || !termino) return null;

      const dataInicio = this.parseDate(inicio);
      const dataTermino = this.parseDate(termino);

      if (!dataInicio || !dataTermino) return null;

      // dataTermino deve ser MAIOR que dataInicio
      if (dataTermino <= dataInicio) {
        return { dateRangeInvalid: true };
      }

      const diffDays = Math.floor(
        (dataTermino.getTime() - dataInicio.getTime()) / 86400000,
      );

      if (diffDays < 7) {
        return { minDuration: { min: 7, actual: diffDays } };
      }

      if (diffDays > 90) {
        return { maxDuration: { max: 90, actual: diffDays } };
      }

      // Data de início não pode ser no passado
      const hoje = new Date();
      hoje.setHours(0, 0, 0, 0);
      if (dataInicio < hoje) {
        return { pastDate: true };
      }

      return null;
    };
  }

  private parseDate(value: any): Date | null {
    if (!value) return null;

    let date: Date;

    if (value instanceof Date) {
      date = new Date(value);
    } else if (typeof value === 'string') {
      // Trata formatos: YYYY-MM-DD, dd/MM/yyyy, ISO string
      if (value.match(/^\d{4}-\d{2}-\d{2}/)) {
        date = new Date(value + 'T00:00:00');
      } else if (value.match(/^\d{2}\/\d{2}\/\d{4}/)) {
        const [day, month, year] = value.split('/');
        date = new Date(`${year}-${month}-${day}T00:00:00`);
      } else {
        date = new Date(value);
      }
    } else {
      return null;
    }

    // Valida se a data é válida
    return isNaN(date.getTime()) ? null : date;
  }

  maxLengthEditor(max: number): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (!control.value) return null;

      // Remove tags HTML e conta apenas o texto
      const text = control.value.replace(/<[^>]*>/g, '').trim();
      return text.length > max
        ? {
            maxlengthEditor: { requiredLength: max, actualLength: text.length },
          }
        : null;
    };
  }

  isInvalid(field: string): boolean {
    const control = this.campanhaForm.get(field);
    return !!(control && control.invalid && (control.dirty || control.touched));
  }

  isInvalidRecompensa(field: string): boolean {
    const control = this.recompensaForm.get(field);
    return !!(control && control.invalid && (control.dirty || control.touched));
  }

  // utilitis
  extractIdFromName(nome: string): number | null {
    if (!nome) return null;
    const match = nome.match(/_(\d+)\./);
    return match ? Number(match[1]) : null;
  }

  stripHtmlTags(value: string): string {
    return value
      ? value
          .replace(/&nbsp;/g, ' ')
          .replace(/<[^>]*>/g, '')
          .trim()
      : '';
  }

  openFile(event: Event, url?: string) {
    event.stopPropagation();
    if (url) window.open(url, '_blank');
  }

  clearForm() {
    this.campanhaForm.reset();
    this.selectedFile = null;
    this.selectedPdF = null;
    this.step = 1;
    this.Isreturn = true;
    this.IsSave = false;
  }

  /** --- Textos explicativos --- **/
  typeFinance = [
    {
      type: 'Doação',
      describe:
        'Contribuições voluntárias feitas sem esperar retorno financeiro. Ideal para causas sociais, emergências, saúde, educação ou apoio comunitário.',
    },
    // {
    //   type: 'Empréstimo',
    //   describe:
    //     'Financiamento coletivo reembolsável. Os apoiadores emprestam dinheiro a um projecto ou pessoa, com ou sem juros, dentro de um prazo acordado.',
    // },
    {
      type: 'Recompensa',
      describe:
        'Os apoiadores recebem uma contrapartida (produto, serviço ou benefício exclusivo) em troca da sua contribuição. Ideal para startups, produtos criativos ou eventos.',
    },
  ];

  CategoryProvince = [
    {
      type: 'Categoria',
      describe:
        'Seleccione a categoria que melhor se adequa ao seu projecto/campanha.',
    },
    {
      type: 'Província',
      describe:
        'Indique a Província onde o seu projecto/campanha será realizado.',
    },
  ];

  private mapAndSortOptions(data: any[]): { label: string; id: number }[] {
    return data
      .map((item) => ({
        label: item.descricao,
        id: item.id,
      }))
      .sort((a, b) =>
        a.label.localeCompare(b.label, 'pt', { sensitivity: 'base' }),
      );
  }

  logInvalidControls(form: FormGroup | FormArray, path: string = ''): void {
    Object.keys(form.controls).forEach((key) => {
      const control = form.get(key);
      const currentPath = path ? `${path}.${key}` : key;

      if (control instanceof FormGroup || control instanceof FormArray) {
        this.logInvalidControls(control, currentPath);
      } else {
        if (control && control.invalid) {
          console.warn('Campo inválido:', currentPath, {
            value: control.value,
            errors: control.errors,
          });
          this.messageService.add({
            severity: 'error',
            summary: 'Campo inválido',
            detail: `Campo ${currentPath} inválido`,
            life: 5000,
          });
        }
      }
    });

    // Erros de nível do grupo (validators customizados)
    if (form.errors) {
      console.error('Erros no grupo:', path || 'ROOT', form.errors);
    }
  }

  private ignoreRecompensaFormValidation(): void {
    const recompensaForm = this.campanhaForm.get('recompensaForm') as FormGroup;
    if (!recompensaForm) return;

    recompensaForm.reset();

    this.clearRecompensaValidators(recompensaForm);

    // limpar recompensas existentes
    this.recompensas.clear();

    recompensaForm.disable({ emitEvent: false });
  }

  private clearRecompensaValidators(form: FormGroup): void {
    form.clearValidators();
    form.updateValueAndValidity({ emitEvent: false });

    Object.values(form.controls).forEach((control) => {
      control.clearValidators();
      control.updateValueAndValidity({ emitEvent: false });
    });
  }

  private handleRecompensaWhenTipo3(): void {
    // only apply logic when campaign type is recompensa
    const tipo = this.campanhaForm.get('tipoFinanciamentoENUM')?.value;
    const recompensaForm = this.campanhaForm.get('recompensaForm') as FormGroup;
    if (!recompensaForm) return;

    if (tipo !== 3) {
      // not a reward campaign, clear everything and disable
      this.ignoreRecompensaFormValidation();
      return;
    }

    const jaTemRecompensas = this.recompensas?.length > 0;

    if (jaTemRecompensas) {
      // at least one reward added → validation no longer required
      this.clearRecompensaValidators(recompensaForm);
      // recompensaForm.disable({ emitEvent: false });
    } else {
      // no rewards yet → require the form to be valid before adding
      recompensaForm.enable({ emitEvent: false });
      this.applyRecompensaValidators(recompensaForm);
    }
  }

  private applyRecompensaValidators(form: FormGroup): void {
    // apply the same validators used elsewhere for the reward group
    form.get('Titulo')?.setValidators([Validators.required]);
    form.get('TipoRecompensaENUM')?.setValidators([Validators.required]);
    form.get('Descricao')?.setValidators([Validators.required]);

    const valorValidators = [
      Validators.required,
      Validators.min(this.limiteMinimoRecompensa || 1),
    ];
    if (
      this.limiteMaximoRecompensa &&
      this.limiteMaximoRecompensa < 1000000000
    ) {
      valorValidators.push(Validators.max(this.limiteMaximoRecompensa));
    }
    form.get('Valor')?.setValidators(valorValidators);

    form
      .get('Quantidade')
      ?.setValidators([Validators.required, Validators.min(1)]);

    // Se estiver editando recompensa existente ou em modo de edição de campanha,
    // não bloqueia com dataPassada para permitir manter ou ajustar datas com flexibilidade
    if (this.editIndex !== null || this.IsEditMode) {
      form.get('DataInicioRecompensa')?.setValidators([Validators.required]);
    } else {
      form
        .get('DataInicioRecompensa')
        ?.setValidators([
          Validators.required,
          dataNaoPodeSerPassadaValidator(),
        ]);
    }

    form.get('DataTerminoRecompensa')?.setValidators([Validators.required]);

    Object.values(form.controls).forEach((control) => {
      control.updateValueAndValidity({ emitEvent: false });
    });
  }

  extrairConfiguracoesRecompensa(grupos: any[]): void {
    if (!Array.isArray(grupos) || grupos.length === 0) return;
    const grupoRecompensa = grupos.find(
      (g: any) => Number(g?.configuracoesGeralENUM ?? g?.id) === 3,
    );
    if (
      grupoRecompensa &&
      Array.isArray(grupoRecompensa.configuracaoParametros)
    ) {
      this.parametrosRecompensaBackend = grupoRecompensa.configuracaoParametros;
      this.processarParametrosRecompensaApi(
        grupoRecompensa.configuracaoParametros,
      );
    }
  }

  carregarParametrosRecompensaDaApi(callback?: () => void): void {
    this.carregandoParametrosRecompensa = true;
    const params = new HttpParams().set('configuracoesGeralENUM', 3);

    this.apiService.get<any>('/Configuracoes/Dominio', params).subscribe({
      next: (res: any) => {
        this.carregandoParametrosRecompensa = false;
        const grupo = (res?.data || res)?.[0];
        const paramsList = grupo?.configuracaoParametros;

        if (Array.isArray(paramsList)) {
          this.parametrosRecompensaBackend = paramsList;
          this.processarParametrosRecompensaApi(paramsList);
        }

        if (callback) callback();
      },
      error: (err) => {
        this.carregandoParametrosRecompensa = false;
        console.error(
          'Erro ao carregar parâmetros da API /Configuracoes/Dominio?configuracoesGeralENUM=3:',
          err,
        );
        if (callback) callback();
      },
    });
  }

  processarParametrosRecompensaApi(paramsList: any[]): void {
    const getVal = (id: number): number | null => {
      const p = paramsList.find(
        (x: any) => Number(x.configuracoesEspecificaENUM) === id,
      );
      if (p && p.valor !== undefined && p.valor !== null && p.valor !== '') {
        const n = Number(String(p.valor).replace(',', '.'));
        return !isNaN(n) ? n : null;
      }
      return null;
    };

    // 1. Valores monetários da API
    this.recompensaDoacaoMinima = getVal(6); // id 6: Doação mínima
    this.recompensaDoacaoMaxima = getVal(7); // id 7: Doação máxima

    // 2. Taxas da API
    this.recompensaComissao = getVal(4); // id 4: Comissão por campanha (%)
    this.recompensaTaxaServico = getVal(5); // id 5: Taxa de serviço (%)
    if (this.recompensaComissao !== null) {
      this.comissaoPorCampanha = this.recompensaComissao;
      const metaAtual =
        Number(this.campanhaForm.get('MetaArrecadar')?.value) || 0;
      if (metaAtual > 0) {
        this.comissao =
          +(metaAtual * this.comissaoPorCampanha).toFixed(2) / 100;
        this.meta = metaAtual + this.comissao;
      }
    }

    // 3. Datas e duração da API
    this.recompensaDuracaoMinima = getVal(8); // id 8: Duração mínima (dias)
    this.recompensaDuracaoMaxima = getVal(9); // id 9: Duração máxima (dias)
    if (this.recompensaDuracaoMinima !== null)
      this.duracaoMin = this.recompensaDuracaoMinima;
    if (this.recompensaDuracaoMaxima !== null)
      this.duracaoMax = this.recompensaDuracaoMaxima;

    // 4. Outros parâmetros da API
    this.recompensaQtdProjetosCriador = getVal(10); // id 10: Qtd. projetos criador
    this.recompensaPrazoAlerta = getVal(11); // id 11: Prazo alerta
    this.recompensaAprovacaoCampanha = getVal(12); // id 12: Aprovação campanha
    this.recompensaCampanhaSucesso = getVal(13); // id 13: Campanha bem sucedida (%)
    if (this.recompensaCampanhaSucesso !== null) {
      this.percentAprovacao = this.recompensaCampanhaSucesso;
    }

    // Sincroniza as opções de duração em dias com o que o back exige
    if (this.recompensaDuracaoMinima && this.recompensaDuracaoMaxima) {
      this.atualizarOpcoesDiasRecompensa(
        this.recompensaDuracaoMinima,
        this.recompensaDuracaoMaxima,
      );
    }

    // Recalcula os limites monetários em tempo de execução
    this.recalcularLimitesRecompensa();
  }

  recalcularLimitesRecompensa(): void {
    const minApi = this.recompensaDoacaoMinima ?? 0;
    const maxApi = this.recompensaDoacaoMaxima ?? 0;

    // Piso mínimo derivado da API ou 1
    this.limiteMinimoRecompensa = minApi > 0 ? minApi : 1;

    // Teto máximo: apenas se for configurado valor monetário absoluto expressivo (> 100)
    if (maxApi > 100) {
      this.limiteMaximoRecompensa = maxApi;
    } else {
      this.limiteMaximoRecompensa = 1000000000;
    }

    this.aplicarValidadoresValorRecompensa();
  }

  atualizarOpcoesDiasRecompensa(durMin: number, durMax: number): void {
    if (durMin <= 0 || durMax <= 0 || durMin > durMax) return;

    // Gera lista dinâmica de opções de dias dentro do range da API
    const novasOpcoes: { name: string; key: string }[] = [];
    const diferenca = durMax - durMin;
    const step = diferenca <= 10 ? 1 : Math.ceil(diferenca / 5);

    for (let d = durMin; d <= durMax; d += step) {
      novasOpcoes.push({ name: String(d), key: String(d) });
    }
    if (!novasOpcoes.some((x) => Number(x.key) === durMax)) {
      novasOpcoes.push({ name: String(durMax), key: String(durMax) });
    }

    this.diasList = novasOpcoes;

    // Se a duração atual selecionada estiver fora do range da API, ajusta automaticamente
    const valorAtual = Number(this.campanhaForm.get('dias')?.value);
    if (!valorAtual || valorAtual < durMin || valorAtual > durMax) {
      this.campanhaForm.get('dias')?.setValue(String(durMin));
      this.campanhaForm.get('dias')?.markAsDirty();
    }

    this.campanhaForm
      .get('dias')
      ?.setValidators([
        Validators.required,
        Validators.min(durMin),
        Validators.max(durMax),
      ]);
    this.campanhaForm.get('dias')?.updateValueAndValidity({ emitEvent: false });
  }

  restaurarOpcoesDiasPadrao(): void {
    this.diasList = [...this.diasListPadrao];
    this.campanhaForm.get('dias')?.setValidators([Validators.required]);
    this.campanhaForm.get('dias')?.updateValueAndValidity({ emitEvent: false });
  }

  aplicarValidadoresValorRecompensa(): void {
    const valorControl = this.recompensaForm?.get('Valor');
    if (valorControl) {
      if (
        this.recompensas?.length > 0 &&
        this.editIndex === null &&
        !valorControl.value
      ) {
        valorControl.clearValidators();
        valorControl.updateValueAndValidity({ emitEvent: false });
        return;
      }

      valorControl.setValidators([
        Validators.required,
        Validators.min(this.limiteMinimoRecompensa),
        Validators.max(this.limiteMaximoRecompensa),
      ]);
      valorControl.updateValueAndValidity({ emitEvent: false });
    }
  }

  validarRecompensasAntesDeEnviar(): boolean {
    if (this.campanhaForm.get('tipoFinanciamentoENUM')?.value !== 3) {
      return true;
    }

    if (!this.recompensas || this.recompensas.length === 0) {
      this.toast(
        'error',
        'Recompensa necessária',
        'Adicione pelo menos uma recompensa para a campanha.',
      );
      return false;
    }

    // 1. Validar duração da campanha contra os parâmetros da API
    if (this.recompensaDuracaoMinima && this.recompensaDuracaoMaxima) {
      const dias = Number(this.campanhaForm.get('dias')?.value) || 0;
      if (
        dias < this.recompensaDuracaoMinima ||
        dias > this.recompensaDuracaoMaxima
      ) {
        this.toast(
          'error',
          'Duração fora dos limites da plataforma',
          `Para campanhas com recompensa, a duração deve ser entre ${this.recompensaDuracaoMinima} e ${this.recompensaDuracaoMaxima} dias. Você selecionou ${dias} dias.`,
        );
        return false;
      }
    }

    // 2. Validar valor de cada recompensa
    this.recalcularLimitesRecompensa();

    for (let i = 0; i < this.recompensas.length; i++) {
      const rec = this.recompensas.at(i).value;
      const valor = Number(rec?.Valor) || 0;
      if (
        valor < this.limiteMinimoRecompensa ||
        valor > this.limiteMaximoRecompensa
      ) {
        this.toast(
          'error',
          'Valor de recompensa fora dos limites',
          `A recompensa "${rec?.Titulo || '#' + (i + 1)}" tem o valor de ${valor.toLocaleString('pt-AO')} Kz, mas o sistema permite entre ${this.limiteMinimoRecompensa.toLocaleString('pt-AO')} e ${this.limiteMaximoRecompensa.toLocaleString('pt-AO')} Kz. Ajuste o valor antes de publicar.`,
        );
        return false;
      }
    }

    // 3. Validar se a data de início de todas as recompensas é POSTERIOR ou IGUAL à data de término da campanha
    // REGRA: Primeiro termina a campanha e só depois se entregam/liberam as recompensas.
    const dataTerminoCampanha = this.getDataTerminoCampanha();
    if (dataTerminoCampanha) {
      const terminoCampanhaNorm = this.normalizarData(dataTerminoCampanha);
      for (let i = 0; i < this.recompensas.length; i++) {
        const rec = this.recompensas.at(i).value;
        if (rec?.DataInicioRecompensa) {
          const inicioRecNorm = this.normalizarData(rec.DataInicioRecompensa);
          if (inicioRecNorm.getTime() < terminoCampanhaNorm.getTime()) {
            this.toast(
              'error',
              'Cronograma de recompensa incompatível',
              `A data de início da recompensa "${rec?.Titulo || '#' + (i + 1)}" (${inicioRecNorm.toLocaleDateString('pt-AO')}) deve ser posterior à data de término da campanha (${dataTerminoCampanha.toLocaleDateString('pt-AO')}), pois as recompensas só são liberadas após a campanha atingir a meta e terminar. Ajuste a data da recompensa ou reduza a duração da campanha.`,
            );
            return false;
          }
        }
      }
    }

    return true;
  }

  parseNumeroAngola(str: string): number {
    if (!str) return 0;
    const limpo = str.trim();
    if (/^\d{1,3}(\.\d{3})+$/.test(limpo)) {
      return Number(limpo.replace(/\./g, ''));
    }
    if (/^\d{1,3}(,\d{3})+$/.test(limpo)) {
      return Number(limpo.replace(/,/g, ''));
    }
    return Number(limpo.replace(',', '.'));
  }

  private isValidGuid(value: string): boolean {
    return /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/.test(
      value,
    );
  }

  // Helper para evitar repetição
  private toast(severity: string, summary: string, detail: string) {
    this.messageService.add({ severity, summary, detail, life: 5000 });
  }

  // removeTermoEmprestimo(index: number) {
  //   const termoCtrl = this.empre.at(index);
  //   if (!termoCtrl) return;

  //   const termoId = termoCtrl.get('Id')?.value;

  //   if (termoId) {
  //     this.RemoverTermosEmprestimosList.push(Number(termoId));
  //   }

  //   this.termosEmprestimos.removeAt(index);
  // }

  gerarPreview(formValue: any) {
    this.ShowPreview = true;
    this.campanhaPreview = {
      titulo: formValue.titulo,
      descricao: formValue.descricao,
      descricaoCurta: this.stripHtmlTags(formValue.descricaoCurta),
      CategoriaID: formValue.CategoriaID,
      ProvinciaID: formValue.ProvinciaID,
      metaArrecadar: Number(this.meta || formValue.MetaArrecadar),
      dias: Number(formValue.dias),
      valorArrecado: 0.0,
      tipoFinanciamentoENUM: formValue.tipoFinanciamentoENUM,
      linkVideo: formValue.linkVideo,
      iban: formValue.iban,
      recompensas: this.recompensas.value,
      redesSociaisList: (this.RedesSociaisList.value || []).filter(
        (s: string) => !!(s && s.trim()),
      ),
    };
  }

  // abrir os ficheiros tirados dos inputs
  openPreviewFile(event: Event, file: File | null) {
    event.stopPropagation();
    if (file) {
      const url = URL.createObjectURL(file);
      window.open(url, '_blank');
    }
  }

  scrollToTop(duration = 300) {
    const start = window.scrollY;
    const startTime = performance.now();
    const step = (now: number) => {
      const t = Math.min(1, (now - startTime) / duration);
      const eased = 1 - Math.pow(1 - t, 3);
      window.scrollTo(0, Math.round(start * (1 - eased)));
      if (t < 1) requestAnimationFrame(step);
    };
    requestAnimationFrame(step);
  }

  parseValor(val: any): number {
    if (val === null || val === undefined || val === '') return 0;
    if (typeof val === 'number') return isNaN(val) ? 0 : val;
    const str = val.toString().trim();
    const cleaned = str
      .replace(/\./g, '')
      .replace(',', '.')
      .replace(/[^0-9.-]/g, '');
    const num = parseFloat(cleaned);
    return isNaN(num) ? 0 : num;
  }

  getCamposStatus(): CampoRequisito[] {
    if (!this.campanhaForm) return [];

    const v = this.campanhaForm.getRawValue();
    const tipo = Number(v.tipoFinanciamentoENUM);

    const campos: CampoRequisito[] = [
      {
        id: 'tipoFinanciamentoENUM',
        label: 'Tipo de Financiamento',
        step: 1,
        valido: [1, 2, 3].includes(tipo),
      },
      {
        id: 'CategoriaID',
        label: 'Categoria do Projecto',
        step: 1,
        valido: !!v.CategoriaID,
      },
      {
        id: 'ProvinciaID',
        label: 'Província / Localização',
        step: 1,
        valido: !!v.ProvinciaID,
      },
    ];

    // Se for empréstimo, valida os 4 parâmetros no Passo 1
    if (tipo === 2) {
      campos.push(
        {
          id: 'ValorSolicitado',
          label: 'Valor Solicitado (Kz)',
          step: 1,
          valido: this.parseValor(v.ValorSolicitado) > 0,
        },
        {
          id: 'QuantidadeParcelas',
          label: 'Quantidade de Parcelas',
          step: 1,
          valido: Number(v.QuantidadeParcelas) > 0,
        },
        {
          id: 'PercentualJuros',
          label: 'Taxa de Juro (%)',
          step: 1,
          valido:
            v.PercentualJuros !== null &&
            v.PercentualJuros !== undefined &&
            v.PercentualJuros !== '',
        },
        {
          id: 'PeriodoReembolsoMeses',
          label: 'Período de Reembolso (Meses)',
          step: 1,
          valido: Number(v.PeriodoReembolsoMeses) > 0,
        },
      );
    }

    // Passo 2
    const titulo = (v.titulo || '').toString().trim();
    const descCurta = (v.descricaoCurta || '').toString().trim();
    const desc = (v.descricao || '').toString().trim();

    campos.push(
      {
        id: 'titulo',
        label: 'Título da Campanha',
        step: 2,
        valido: !!titulo,
      },
      {
        id: 'descricaoCurta',
        label: 'Descrição Curta',
        step: 2,
        valido:
          !!descCurta && !this.campanhaForm.get('descricaoCurta')?.invalid,
      },
      {
        id: 'descricao',
        label: 'História do Projecto',
        step: 2,
        valido: !!desc && !this.campanhaForm.get('descricao')?.invalid,
      },
      {
        id: 'capaProjeto',
        label: 'Imagem de Capa',
        step: 2,
        valido: !!(this.selectedFile || this.imgPreview || v.capaProjeto),
      },
      {
        id: 'docProjeto',
        label: 'Documento de Apresentação (PDF)',
        step: 2,
        valido: !!(this.selectedPdF || this.docPreview || v.docProjeto),
      },
      {
        id: 'videoProjeto',
        label: 'Vídeo da Campanha (Ficheiro ou Link)',
        step: 2,
        valido: !!(
          this.selectedVideo ||
          this.vidPreview ||
          v.videoProjeto ||
          (v.linkVideo && v.linkVideo.toString().trim())
        ),
      },
    );

    // Passo 3
    if (tipo !== 2) {
      campos.push({
        id: 'MetaArrecadar',
        label: 'Meta de Angariação (Kz)',
        step: 3,
        valido: this.parseValor(v.MetaArrecadar) > 0,
      });
    }

    campos.push({
      id: 'dias',
      label: 'Duração da Campanha (Dias)',
      step: 3,
      valido: Number(v.dias) > 0,
    });

    if (tipo === 3) {
      campos.push({
        id: 'recompensas',
        label: 'Pelo menos 1 Recompensa Adicionada',
        step: 3,
        valido: !!(this.recompensas && this.recompensas.length > 0),
      });
    }

    return campos;
  }

  getPercentualPreenchimento(): number {
    const campos = this.getCamposStatus();
    if (!campos || campos.length === 0) return 0;
    const preenchidos = campos.filter((c) => c.valido).length;
    return Math.round((preenchidos / campos.length) * 100);
  }

  getCamposPendentes(): CampoRequisito[] {
    return this.getCamposStatus().filter((c) => !c.valido);
  }

  isFormularioCompleto(): boolean {
    return this.getPercentualPreenchimento() === 100;
  }

  focarCampoPendente(campo: CampoRequisito) {
    if (this.step !== campo.step) {
      this.goToStep(campo.step);
    }
    setTimeout(() => {
      const el = document.getElementById(campo.id);
      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'center' });
        el.focus();
      }
    }, 350);
  }
}
